import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from 'ionic-angular';
import { DirectivesModule } from '../directives/directives.module';
import { PipesModule } from '../pipes/pipes.module';
import { CommonFooterComponent } from './common-footer/common-footer';
import { CommonHeaderComponent } from './common-header/common-header';
import { SanitizerComponent } from './sanitizer/sanitizer';
import { ShopDataComponent } from './shop-data/shop-data';
import { MapComponent } from './map/map';
import { ShopFavoriteComponent } from './shop-favorite/shop-favorite';
import { ScannerComponent } from './scanner/scanner';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ScrollTabComponent } from './scroll-tab/scroll-tab';
import { RssComponent } from './rss/rss';
import { HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PushReactionComponent } from './push-reaction/push-reaction';
import { MemberCardComponent } from './member-card/member-card';
@NgModule({
	declarations: [CommonFooterComponent,
    CommonHeaderComponent,
    SanitizerComponent,
    ShopDataComponent,
    MapComponent,
    ShopFavoriteComponent,
    ScannerComponent,
    ScrollTabComponent,
    RssComponent,
    PushReactionComponent,
    MemberCardComponent],
	imports: [
		CommonModule,
        IonicModule,
        DirectivesModule,
        PipesModule,
        ZXingScannerModule.forRoot(),
        TranslateModule.forChild({
        loader: {
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [HttpClient]
            }
        }),
	],
	exports: [CommonFooterComponent,
    CommonHeaderComponent,
    SanitizerComponent,
    ShopDataComponent,
    MapComponent,
    ShopFavoriteComponent,
    ScannerComponent,
    ScrollTabComponent,
    RssComponent,
    PushReactionComponent,
    MemberCardComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ComponentsModule {}
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');
  }



// WEBPACK FOOTER //
// ./src/components/components.module.ts